// Realistic brand photography (Unsplash CDN, Unsplash License)
const U = (id, w = 1800, extra = "") => `https://images.unsplash.com/photo-${id}?w=${w}&q=70&auto=format&fit=crop${extra}`;
const ICON = (id) => U(id, 96, "&h=96");

const IDS = {
  island: "1778090887585-b27fae5b6f03",
  shore: "1507525428034-b723cf961d3e",
  happyHour: "1514362545857-3bc16c4c7d1b",
  lounge: "1752693916212-28f1d968aeb0",
  galleon: "1774031826492-3d859b950574",
  frigate: "1590880449155-b54f958ce314",
  bank: "1764983255241-3768b4df0c57",
  library: "1772976811682-465df3b8c735",
  helm: "1463567517034-628c51048aa2",
  compass: "1764042082382-d68eaeaa53f9",
  pen: "1744402021279-1dff8880d207",
  seal: "1646568779353-b9d2b903b3e1",
  brothers: "1758518731224-100f6a30bffc",
  bottle: "1487427076583-392ed176865e",
  oracle: "1532012197267-da84d127e765",
  fliers: "1530103862676-de8c9debad1d",
  cake: "1464349095431-e9a21285b5f3",
};

export const ISLAND_HERO = U(IDS.island);
export const ISLAND_ICON = ICON(IDS.island);
export const ISLAND_SHORE = U(IDS.shore);
export const HAPPY_HOUR_HERO = U(IDS.happyHour);
export const HAPPY_HOUR_ICON = ICON(IDS.happyHour);
export const HAPPY_HOUR_LOUNGE = U(IDS.lounge);

// Navigation photo icons (realistic, on-brand)
export const NAV_ICONS = {
  "/dashboard": ICON(IDS.galleon),
  "/messages": ICON(IDS.bottle),
  "/island": ISLAND_ICON,
  "/happy-hour": HAPPY_HOUR_ICON,
  "/office": ICON(IDS.bank),
  "/oracle": ICON(IDS.oracle),
  "/fliers": ICON(IDS.cake),
  "/population": ICON(IDS.brothers),
  "/frigates": ICON(IDS.frigate),
  "/directory": ICON(IDS.brothers),
  "/library": ICON(IDS.library),
  "/progress": ICON(IDS.compass),
  "/feedback": ICON(IDS.pen),
  "/invite": ICON(IDS.seal),
  "/command": ICON(IDS.helm),
};

// Page hero banners
export const HEROES = {
  office: U(IDS.bank),
  oracle: U(IDS.oracle),
  fliers: U(IDS.fliers),
  population: U(IDS.brothers),
  frigates: U(IDS.frigate),
  library: U(IDS.library),
  directory: U(IDS.brothers),
  progress: U(IDS.compass),
  feedback: U(IDS.pen),
  invite: U(IDS.seal),
  command: U(IDS.helm),
  galleon: U(IDS.galleon),
};
